
// export const API_URL =`https://api.shinedecoration.com`
export const API_URL ='https://api.oluxe.in';

// 'http://35.154.132.235:5000'

// `https://api.shinedecoration.com`


